<script lang="ts">
	import Button from "@components/common/Button.svelte";
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import Formatted from "@components/common/Formatted.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import { Cart } from "../../cart/Cart.svelte.js";
	import translations from "./OrderError.translations.json" with { type: "json" };

	const translate = getTranslate(translations);

	const { message }: { message: string | undefined } = $props();
</script>

<p class="mt-5 text-fcrdarkgray">
	<Formatted text={message ?? translate("unknownError")} />
</p>
<div class="flex justify-end mt-8">
	<Button
		variant={ButtonVariant.Dark}
		size={ButtonSize.Medium}
		onclick={(): void => {
			Cart.closeCartModal();
		}}
	>
		<Formatted text={translate("ok")} />
	</Button>
</div>
